import { context } from '@/contexts/GlobalContext';

export const getCloudinaryConfig = (): string => {
  const CLOUDINARY_PATH = context.get<string>('cloudinaryPath');
  const CLOUDINARY_DIR = context.get<string>('cloudinaryDir');
  if (!CLOUDINARY_PATH || !CLOUDINARY_DIR) return '';

  const CLOUDINARY_URL = `${CLOUDINARY_PATH}/v1652263914/${CLOUDINARY_DIR}`;
  return CLOUDINARY_URL;
};
